import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { makeStyles, Button, lighten, darken } from '@material-ui/core';
import NoQuoteAvailable from '../../Common/SubComponents/NoQuoteAvailable';
import DigitalCoverageAmounts from '../../../Helpers/Lists/CoverageAmounts/DigitalCoverageAmounts.js';
import {
  getSessionStorageItem,
  setSessionStorageItem,
  SESSION_STORAGE_ACCOUNT_KEY,
  SESSION_STORAGE_ACTIVE_PURL,
  SESSION_STORAGE_TERM_SORT_FILTER_KEY,
  SESSION_STORAGE_TERM_STRUCTURE,
  SESSION_STORAGE_AMERICO_OBJECT_KEY,
  SESSION_STORAGE_EMAIL_CAPTURE,
  SESSION_STORAGE_SAVED_QUOTE_DATA,
  getBasicInfo,
  setBasicInfo,
} from '../../../../sessionStorage';
import GetProductTypeEnum from '../../../../types/productType';
import GetAmericoHealthClass from '../../MCT/Helpers/GetAmericoHealthClass';
import { saveSessionEvent } from '../../../../session';
import ProductDetails from '../../FullUW/Helpers/ProductDetails';
import './Quoter.scss';
import { GetMCTQuotes } from '../Common/GetMCTQuotes';
import TermInsuranceTools from '../QuoterComponents/TermInsuranceTools';
import TermQuoteCard from '../QuoterComponents/TermQuoteCard';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import RemoveCircleOutlineOutlinedIcon from '@material-ui/icons/RemoveCircleOutlineOutlined';
import BasicInfoSummary from '../../CustomizeTerm/QuoterComponents/BasicInfoSummary';
import AmericoQuoteModel from '../QuoterComponents/AmericoQuoteModel';
import AmericoProductData from '../../AmericoLoanProtection/Common/AmericoProductData.js';
import QuoterFilters from '../QuoterComponents/QuoterFilters';
import SaveQuoteButton from '../SaveTermQuote/SaveQuoteButton';
import { ContactSpecialist } from '../Common/ContactSpecialist';
import QuoterFilter from '../Helpers/QuoterFilter';
import QuoterSort from '../QuoterComponents/QuoterSort';
import { QuoteProductID } from '../../Common/QuoteProductID';
import LoadingGrid from '../Helpers/LoadingGrid';
import BasicInfoSummaryModel from '../../Common/SubComponents/BasicInfoSummaryModel';
import CtaSolution from '../../Common/CtaSolution/CtaSolution';
import Testimonials from '../../../Common/Testimonials/Testimonials.js';

export default function Quoter(props) {

  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
  const useStyles = makeStyles(theme => ({
    primaryColor: {
      color: theme.palette.primary.main,
    },
    buttonClass: {
      border: 'none',
      backgroundColor: 'inherit',
      color: theme.palette.primary.main,
    },
    darkenText: {
      color: darken(theme.palette.primary.main, 0.5),
    },
    toggleBackground: {
      backgroundColor: lighten(theme.palette.primary.main, 0.95),
    },
    PromotedProductBackgroundImage: {
      backgroundImage: "url(/Tools/perm_banner.jpg)",
    },
    PromotedProductBackgroundColor: {
      backgroundColor: lighten(theme.palette.primary.main, 0.95),
    },
  }));

  const classes = useStyles();
  useEffect(() => {
    saveSessionEvent();
  }, [props.location]);

  const basicInfo = getBasicInfo();
  const termSettings = getSessionStorageItem(SESSION_STORAGE_TERM_SORT_FILTER_KEY);
  const emailCapture = getSessionStorageItem(SESSION_STORAGE_EMAIL_CAPTURE);
  const savedQuote = getSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA);

  if (!basicInfo.birthdate && !basicInfo.fakeBirthdate) {
    window.location.replace('/landing/term-insurance');
  };

  const [loading, setLoading] = useState(true);
  const [americoLoading, setAmericoLoading] = useState(false);
  const [termLength, setTermLength] = useState(props.formState.coverageLength || props.preQuoteDetails.termQuote || 20);
  const [coverageAmount, setCoverageAmount] = useState(props.basicInfo.faceAmount || parseInt(props.formState.coverageAmount, 10) || props.preQuoteDetails.coverageAmountQuote);
  const [healthClass, setHealthClass] = useState(props.formState.healthClass || props.preQuoteDetails.healthClass || 'PP');
  const quoteResultTermStructure = getSessionStorageItem(SESSION_STORAGE_TERM_STRUCTURE);
  const [termStructure, setTermStructure] = useState(props.formState.termStructure);
  const [multiTermFilter, setMultiTermFilter] = useState(false);
  const [multiTermResult, setMultiTermResult] = useState(props.multiTermResult);
  const [quoteResults, setQuoteResults] = useState([]);
  const [displayAllQuotes, setDisplayAllQuotes] = useState(false);
  const [filteredQuoteResults, setFilteredQuoteResults] = useState([]);
  const [americoQuoteResult, setAmericoQuoteResult] = useState([]);
  const [displayedQuoteResults, setDisplayedQuoteResults] = useState(filteredQuoteResults);
  const [displayedAmericoQuoteResult, setDisplayedAmericoQuoteResult] = useState(americoQuoteResult);
  const [fastestRate, setFastestRate] = useState('');
  const [isSortedByPrice, setSortedByPrice] = useState((termSettings !== null && termSettings.sortByPrice !== null) ? termSettings.sortByPrice : true);
  const [filterObject, setFilterObject] = useState((termSettings !== null && termSettings.filters !== null) ? termSettings.filters : null);
  const [lowestPrice, setlowestPrice] = useState('');
  const [americoModalShow, setAmericoModalShow] = useState(false);
  const [quoteLogId, setQuoteLogId] = useState(null);
  const [isQuoteSaved, setQuoteSaved] = useState(savedQuote.quoteSaved);
  const [errorMessage, setErrorMessage] = useState({ message: '', status: '' });
  const [basicInfoModalShow, setBasicInfoModalShow] = useState(false);
  const handleAmericoModalClose = () => setAmericoModalShow(false);
  const handleAmericoModalShow = () => setAmericoModalShow(true);
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const getActivePurlData = getSessionStorageItem(SESSION_STORAGE_ACTIVE_PURL);
  const isActivePurl = getActivePurlData ? getActivePurlData.active : false;
  const [isPurlVerification, setIsPurlVerification] = useState(isActivePurl);
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [enableInitialEmailCapture, setEnableInitialEmailCapture] = useState(accountObj.account.enableInitialEmailCapture);
  const [enableTimeoutEmailCapture, setEnableTimeoutEmailCapture] = useState(accountObj.account.enableTimeoutEmailCapture);
  const [initialEmailCaptureDisplayed, setInitialEmailCaptureDisplayed] = useState(emailCapture.initialEmailCaptureDisplayed || false);
  const [timeoutEmailCaptureDisplayed, setTimeoutEmailCaptureDisplayed] = useState(emailCapture.timeoutEmailCaptureDisplayed || false);
  const [quoteLowestPrice, setQuoteLowestPrice] = useState(null);
  const [quoteFastestProcess, setQuoteFastestProcess] = useState(null);
  const [quoteMostPopular, setQuoteMostPopular] = useState(null);
  const [saveQuoteData, setSaveQuoteData] = useState(null);
  const [saveQuoteContact, setSaveQuoteContact] = useState(savedQuote);
  const filterRef = useRef();
  const isTestimonialPanelEnable = accountObj && accountObj.account && accountObj.account.isTestimonialPanelEnable;

  const isHavenSI = accountObj.accountProducts.some((item) => {
    return item.productTypeId === GetProductTypeEnum().HavenSI;
  });

  const accountProductTypeSettings = props ? accountObj.accountProducts.find(product => product.productLandingUrl === '/landing/term-insurance' || product.productLandingUrl === '/landing/loan-protection') : null;
  const accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ?
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;
  const utmQuoterCarrierId = accountLandingOverride ? accountLandingOverride.quoterCarrierId : null;
  const promotedProducts = JSON.parse(accountObj.account.promotedProducts);
  const promotedProductCount = promotedProducts ? promotedProducts.filter(p => p.isEnabled).length : 0;
  const quotesWithoutAmerico = filteredQuoteResults && filteredQuoteResults.filter(quote => quote.productID !== QuoteProductID.AMERICO_TERM_PRODUCT_ID);

  const quoteResultsValueProp = 'Defined by your answers, these options are ranked based on price, features and application process. Please note: all options offer a 10 to 30 day money back guarantee (or according to your state regulations) referred to as a "Free Look Period".';

  useEffect(() => {
    window.scroll(0, 0);
    if (props.formState.coverageAmount !== '' && props.formState.coverageAmount !== 0 && (props.isAmerico || props.formState.coverageAmount !== props.preQuoteDetails.coverageAmountQuote)) {
      setCoverageAmount(props.formState.coverageAmount);
    } else {
      if (!props.isAmerico) {
        setCoverageAmount(props.preQuoteDetails.coverageAmountQuote);
      }
    }
    if (props.formState.coverageLength !== '' && props.formState.coverageLength !== 0 && (props.isAmerico || props.formState.coverageLength !== props.preQuoteDetails.termQuote)) {
      setTermLength(props.formState.coverageLength);
    } else {
      setTermLength(props.preQuoteDetails.termQuote);
    }
    if (props.formState.healthClass !== '' && (props.isAmerico || props.formState.healthClass !== props.preQuoteDetails.healthClass)) {
      setHealthClass(props.formState.healthClass);
    } else {
      setHealthClass(props.preQuoteDetails.healthClass);
    }

    setTermStructure(props.formState.termStructure);
  }, []);

  useEffect(() => {
    if (quoteResults.length > 0) {
      quoteResults.sort((a, b) => b.speedScore - a.speedScore || a.monthlyRate - b.monthlyRate || b.totalUnweightedScore - a.totalUnweightedScore)[0];
      quoteResults[0].isFastest = true;
      setFastestRate(quoteResults[0].monthlyRate);
      quoteResults.sort((a, b) => a.monthlyRate - b.monthlyRate || b.totalUnweightedScore - a.totalUnweightedScore)[0];
      setlowestPrice(quoteResults[0].monthlyRate);
      quoteResults[0].isBestPrice = true;

      quoteResults.forEach(qr => {
        qr.isFeaturedCarrier = utmQuoterCarrierId === (qr.carrierID ? qr.carrierID : null);
      });

      quoteResults.sort((a, b) => sorter(a, b, isSortedByPrice ? 'price' : 'speed'));
      const filteredQuotes = filterResults(quoteResults);
      setFilteredQuoteResults(filteredQuotes);

    } else {
      setFilteredQuoteResults([]);
    }

    if (props.isAmerico && quoteResults) {
      const tobacco = basicInfo.tobacco !== 'Never' && basicInfo.tobacco !== 'false';
      setAmericoLoading(true);
      fetch(`${covrServicesUrl}/api/Americo?faceAmount=${coverageAmount}&term=${termLength}&state=${basicInfo.state}&birthdate=${basicInfo.birthdate || basicInfo.fakeBirthdate}&healthClass=${healthClass}&gender=${basicInfo.gender}&tobacco=${tobacco}`,
      {
        method: 'GET',
        headers: {
          'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
        },
      })
      .then(res => res.json())
      .then(data => {
        const americoQuote = [{...data, ...AmericoProductData()}];
        if (americoQuote) {
          setDisplayedAmericoQuoteResult(americoQuote);
        }
        setAmericoLoading(false);
      })
      .finally(() => {
        setAmericoLoading(false);
      });
    }
  }, [quoteResults]);

  const getQuoteFastestProcess = (results, lowest) => {
    const sortedResults = results.sort((a, b) => a.speedScore - b.speedScore);
    const product = results.find(product => !!product.isFastest);

    if (product && lowest && product.productID === lowest.productID) {
      return sortedResults[sortedResults.length - 2];
    }
    return product;
  };

  const getQuoteMostPopular = (results, fastest, lowest) => {
    const productIds = [QuoteProductID.LGA_PRODUCT_ID, QuoteProductID.BANNER_OPTERM_PRODUCT_ID, QuoteProductID.PENN_OPTERM_PRODUCT_ID, QuoteProductID.SYMETRA_SWIFT_TERM_PRODUCT_ID, QuoteProductID.PACIFIC_LIFE_PROMISE_TERM_PRODUCT_ID, QuoteProductID.AMERICO_TERM_PRODUCT_ID];

    if (!props.isAmerico && fastest && lowest ) {
      let product = null;
  
      for (const id of productIds) {
        product = results.find(product => product.productID === id && fastest.productID !== id && lowest.productID !== id);
        if (product) {
          break;
        }
      }
      return product;
    } 
    if (props.isAmerico && fastest && lowest) {
      let product = null;

      product = results.find(product => product.productID === QuoteProductID.AMERICO_TERM_PRODUCT_ID && fastest.productID !== QuoteProductID.AMERICO_TERM_PRODUCT_ID && lowest.productID !== QuoteProductID.AMERICO_TERM_PRODUCT_ID);

      if (product) {
        return product;
      } else {

        for (const id of productIds) {
          product = results.find(product => product.productID === id && fastest.productID !== id && lowest.productID !== id);
          if (product) {
            break;
          }
        }
        return product;
      }
    }
  };

  const setQuoteValues = () => {
    const quotedLowestPrice = quoteResults.find(product => !!product.isBestPrice);
    const quotedFastestProcess = getQuoteFastestProcess(quoteResults, quotedLowestPrice);
    const quotedMostPopular = getQuoteMostPopular(quoteResults, quotedFastestProcess, quotedLowestPrice);

    const lowestPriceOdj = {
      carrierLogo: quotedLowestPrice && quotedLowestPrice.logoUrl,
      rating: quotedLowestPrice && quotedLowestPrice.rating,
      monthlyRate: quotedLowestPrice && quotedLowestPrice.monthlyRate && quotedLowestPrice.monthlyRate.toFixed(2),
    };

    const fastestProcessOdj = {
      carrierLogo: quotedFastestProcess && quotedFastestProcess.logoUrl,
      rating: quotedFastestProcess && quotedFastestProcess.rating,
      monthlyRate: quotedFastestProcess && quotedFastestProcess.monthlyRate && quotedFastestProcess.monthlyRate.toFixed(2),
    };

    const mostPopularOdj = {
      carrierLogo: quotedMostPopular && quotedMostPopular.logoUrl,
      rating: quotedMostPopular && quotedMostPopular.rating,
      monthlyRate: quotedMostPopular && quotedMostPopular.monthlyRate && quotedMostPopular.monthlyRate.toFixed(2),
    };

    setQuoteLowestPrice(lowestPriceOdj);
    setQuoteFastestProcess(fastestProcessOdj);
    setQuoteMostPopular(mostPopularOdj);
  };

  const setCurrentSavedQuoteData = () => {
    const newData = getSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA);
    setSaveQuoteContact(newData);
  }

  const trimString = (str) => {
    if (str !== null) {
      return str.replace(/\s+/g, " ");
    }
    return "";
  }

  useEffect(() => {
    if(quoteResults.length > 0) {
      setQuoteValues();
    }
  }, [loading]);

  const covrDisclaimer = 'Insurance products are sold through Covr Financial Technologies Inc ("Covr"). Covr sells insurance as an agent or broker by contractual agreements with its insurance carrier providers. Covr is licensed in the following states: Delaware (3000067942), Idaho (607086), California (0L77229).';

  useEffect(() => {
    const quoteData = {
      accountId: accountObj.account.accountId,
      accountName: accountObj.account.accountName,
      oneClickAccountId: accountObj.account.oneClickAccountId,
      accountProductTypeSettingId: accountProductTypeSettings.accountProductTypeSettingId,
      productType: props.isAmerico ? "LoanProtector" : "TermA",
      sessionId: accountObj.sessionId,
      accountColorLogoUrl: accountObj.account.logoUrl,
      firstName: saveQuoteContact.firstName,
      emailAddress: saveQuoteContact.emailAddress,
      gender: basicInfo.gender,
      dateOfBirth: basicInfo.birthdate,
      state: basicInfo.state,
      height: trimString(basicInfo.height),
      weight: trimString(basicInfo.weight),
      tobaccoStatus: props.isAmerico ? (basicInfo.tobacco !== 'Never' && basicInfo.tobacco !== 'false') : basicInfo.tobacco,
      coverageAmount: coverageAmount,
      termLength: termLength,
      healthClass: healthClass,
      quoteLowestPrice: quoteLowestPrice,
      quoteFastestProcess: quoteFastestProcess,
      quoteMostPopular: quoteMostPopular,
      quotedLowestPrice: !!quoteLowestPrice ? quoteLowestPrice.monthlyRate : null,
      signatureEmail: "insuranceapplication@covrtech.com",
      signaturePhone: accountObj.account.phone,
      covrDisclaimer: covrDisclaimer,
      disclaimerHtml: accountObj.account.disclaimerHtml ? accountObj.account.disclaimerHtml : null,
    };
    setSaveQuoteData(quoteData);
  }, [quoteLowestPrice, quoteFastestProcess, quoteMostPopular, termLength, coverageAmount, healthClass, saveQuoteContact]);

  useEffect(() => {
    if (saveQuoteContact.emailAddress !== "") {
      setSessionStorageItem(SESSION_STORAGE_SAVED_QUOTE_DATA, {
        "quoteSaved": isQuoteSaved,
        "firstName": saveQuoteContact.firstName,
        "emailAddress": saveQuoteContact.emailAddress,
      });
    }
    setCurrentSavedQuoteData();
  }, [isQuoteSaved]);

  useEffect(() => {
    quoteResultTermStructure ? isMultiTermFilter(quoteResultTermStructure.multiTerm) : isMultiTermFilter(false);
    if (quoteResultTermStructure && quoteResultTermStructure.multiTerm) {
      setMultiTermResult(quoteResultTermStructure.multiTerm);
    }
  }, [props.multiTermResult]);

  useEffect(() => {
    setSessionStorageItem(SESSION_STORAGE_TERM_STRUCTURE, { multiTerm: multiTermResult });
    isMultiTermFilter(multiTermResult);
  }, [multiTermResult]);

  const isMultiTermFilter = (multiTermResult) => {
    if (!multiTermResult) {
      setMultiTermFilter(false);
    } else {
      setMultiTermFilter(true);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const setTimeoutEmailDisplayed = () => {
    setTimeoutEmailCaptureDisplayed(true);
  };

  const setInitialEmailDisplayed = () => {
    setInitialEmailCaptureDisplayed(true);
  };

  const sorter = (a, b, sortByField) => {
    switch (sortByField) {
      case 'price':
        return a.monthlyRate - b.monthlyRate || b.totalUnweightedScore - a.totalUnweightedScore;
      case 'speed':
        return b.speedScore - a.speedScore || a.monthlyRate - b.monthlyRate || b.totalUnweightedScore - a.totalUnweightedScore;
      default:
        break;
    }
  };

  const quoteLogIdCallback = (quoteLogId) => {
    setQuoteLogId(quoteLogId);
  };

  const runQuote = (getIsSubscribed) => {
    setlowestPrice(null);
    setFastestRate(null);
    setLoading(true);
    GetMCTQuotes(getBasicInfo(), healthClass, coverageAmount, termLength, setLoading, getIsSubscribed, setMultiTermResult, setQuoteResults, termStructure, quoteResultTermStructure, quoteLogIdCallback, isActivePurl);
    scrollToTop();
    setErrorMessage({ status: '', message: '' });
  };

  let debounce = null;
  const setQuoteTimer = () => {

    let isSubscribed = true;

    if (debounce) {
      clearTimeout(debounce);
    }

    debounce = setTimeout(() => runQuote(() => isSubscribed), 1000);

    return () => {
      clearTimeout(debounce);
      isSubscribed = false;
    };
  };

  useEffect(() => {
    if (americoModalShow || basicInfoModalShow) {
      return;
    }

    if (!termLength || !healthClass || !coverageAmount) {
      return;
    }

    return setQuoteTimer();
  }, [termLength, healthClass, coverageAmount, props.basicInfo, termStructure]);

  useEffect(() => {
    const sortByPrice = isSortedByPrice; 
    const filters = filterObject;
    const term = {
      coverageAmount: coverageAmount,
      termLength: termLength,
      healthClass: healthClass,
    };

    setSessionStorageItem(SESSION_STORAGE_TERM_SORT_FILTER_KEY, { term: term, filters: filters, sortByPrice: sortByPrice });
  }, [termLength, healthClass, coverageAmount, filterObject, isSortedByPrice]);

  const convertTermToAmericoHealthClass = (healthClass) => {
    const hc = healthClass.toLowerCase();
    let americoHealthClass;

    switch (hc) {
      case "pp":
        americoHealthClass = "best";
        break;
      case "p":
        americoHealthClass = "better";
        break;
      case "r":
        americoHealthClass = "good";
        break;
      default:
        americoHealthClass = hc;
        break;
    };
    return americoHealthClass;
  };

  const handleQuoteSelection = (quoteInfo, callbacks) => {

    const { onNext, onNextBestow, onNextHaven, onNextLga } = callbacks;
    const { selectedQuote } = quoteInfo;

    if (!selectedQuote.quoteLogId) {
      selectedQuote.quoteLogId = quoteLogId;
    }


    switch (selectedQuote.productID) {

      case QuoteProductID.HAVEN_TERM_PRODUCT_ID:
      case QuoteProductID.HAVEN_SI_PRODUCT_ID:
        onNextHaven();
        break;
      case QuoteProductID.BESTOW_PRODUCT_ID:
        onNextBestow();
        break;
      case QuoteProductID.LGA_PRODUCT_ID:
        onNextLga();
        break;

      default:
        onNext();
        break;
    }
  };

  const handleHealthClassChange = (event) => {
    setHealthClass(event);
  };

  const quoteOnClick = (quote) => {
    const basicInfo = getBasicInfo();
    if (isActivePurl && !basicInfo.birthdate) {
      setIsPurlVerification(true);
      setBasicInfoModalShow(true);
      setSelectedQuote(quote);
    } else {
      const form = { ...props.fullFormState };
      form.pages.quoter.coverageAmount = coverageAmount;
      form.pages.quoter.coverageLength = parseInt(termLength);
      form.pages.quoter.termLength = termLength;
      form.pages.quoter.term = termLength;
      form.pages.quoter.healthClass = healthClass;
      form.pages.quoter.isSelectOrTalk = "quoteSelect";
      if (props.isAmerico) {
        form.steps.quoter.coverageAmount = coverageAmount;
        form.steps.quoter.coverageLength = parseInt(termLength);
        form.steps.quoter.termLength = termLength;
        form.steps.quoter.term = termLength;
        form.steps.quoter.healthClass = convertTermToAmericoHealthClass(healthClass);
      }
      props.onMultiFieldChange(form);

      basicInfo.faceAmount = coverageAmount;
      basicInfo.termLength = termLength;
      basicInfo.healthClass = healthClass;
      setBasicInfo(basicInfo);

      const quoteInfo = {
        coverageAmount: coverageAmount,
        termLength: termLength,
        healthClass: healthClass,
        isHavenSI: isHavenSI,
        selectedQuote: quote,
      };

      const callbacks = {
        onNext: props.onNext,
        onNextBestow: props.onNextBestow,
        onNextHaven: props.onNextHaven,
        onNextLga: props.onNextLga,
      };

      handleQuoteSelection(quoteInfo, callbacks);
    }
  };

  const filterResults = (quotes) => {
    return QuoterFilter.filterResults(filterObject, quotes);
  };

  const sortResults = (quotes) => {
    if (!isSortedByPrice) {
      quotes.sort((a, b) => b.speedScore - a.speedScore || a.monthlyRate - b.monthlyRate || b.totalUnweightedScore - a.totalUnweightedScore)[0];
      quotes[0].isFastest = true;
    } else if (isSortedByPrice) {
      quotes.sort((a, b) => a.monthlyRate - b.monthlyRate || b.totalUnweightedScore - a.totalUnweightedScore)[0];
    } else {
      return;
    }
    quotes.sort((a, b) => sorter(a, b, isSortedByPrice ? 'price' : 'speed'));
    return quotes;
  };

  useEffect(() => {
    let quotesList = filterResults(quoteResults);
    if (quotesList.length) {
      quotesList = sortResults(quotesList);
    }
    setFilteredQuoteResults(quotesList);
  }, [filterObject, isSortedByPrice]);

  const quoteLimit = (filteredQuoteResults.some(r => r.isFeaturedCarrier === true) ? 4 : 3);

  const toggleQuoteResults = () => {
    setDisplayAllQuotes(displayAllQuotes => !displayAllQuotes);
  };

  useEffect(() => {
    if (!displayAllQuotes && filteredQuoteResults.length > quoteLimit) {
      const limitedQuotes = props.isAmerico ? quotesWithoutAmerico.slice(0, quoteLimit) : filteredQuoteResults.slice(0, quoteLimit);
      const isFeaturedCarrierQuote = filteredQuoteResults.some(r => r.isFeaturedCarrier === true);
      const featuredCarrierIndex = isFeaturedCarrierQuote && filteredQuoteResults.findIndex(x => x.isFeaturedCarrier === true) || 0;
      if (isFeaturedCarrierQuote && featuredCarrierIndex >= quoteLimit) {
        let quoteList = filteredQuoteResults;
        quoteList = [...quoteList.slice(0, quoteLimit - 1), quoteList[featuredCarrierIndex]];
        setDisplayedQuoteResults(quoteList);
      }
      else {
        setDisplayedQuoteResults(limitedQuotes);
      }
    }
    else {
      setDisplayedQuoteResults(filteredQuoteResults);
    }
  }, [displayAllQuotes, filteredQuoteResults]);

  const redirect = () => {
    props.onNext();
  };

  const setOpenEditPopUp = (open) => {
    if (open) {
      setIsPurlVerification(false);
    }
    setBasicInfoModalShow(open);
  };

  const getSpecialistHelp = () => {
    if (isActivePurl && !basicInfo.birthdate) {
      setIsPurlVerification(false);
      setBasicInfoModalShow(true);
    } else {
      ContactSpecialist(props.fullFormState, coverageAmount, termLength, healthClass, quoteResults, redirect, props.onMultiFieldChange, props.isAmerico);
    }
  };

  const handleContactChange = (contact) => {
    setSaveQuoteContact(contact);
  };

  const handleBasicInfoSubmit = (open, purlMismatch) => {
    setBasicInfoModalShow(open);
    const basicInfo = getBasicInfo();
    setBasicInfo(basicInfo);
    if (isPurlVerification && !purlMismatch) {
      quoteOnClick(selectedQuote);
    } else {
      setQuoteTimer();
    }
  };

  const handleAmericoQuoteOnNext = (props) => {
    const form = { ...props.fullFormState };
    const basicInfo = getBasicInfo();
    const healthClassValue = GetAmericoHealthClass(props.healthClass);
    const tobacco = form.steps.basicInfo.tobacco === 'true' ? 'Over 36 months' : 'Never';
    const AMERICO_SESSION_STORAGE_KEY = "AMERICO_QUOTE";
    const customData = {
        coverageAmount: props.coverageAmount,
        healthClass: healthClassValue,
        premium: form.steps.quoter.premium,
        term: props.termLength,
        cashValue: form.steps.quoter.cashValue,
        // logoUrl: form.steps.quoter.logoUrl,
        backUrl:'/loan-protection/quote-results',
        tobacco : tobacco,
        isFromAmerico : true,
    };

    basicInfo.faceAmount = props.coverageAmount;
    basicInfo.coverageLength = props.termLength;
    setBasicInfo(basicInfo);
    setSessionStorageItem(SESSION_STORAGE_AMERICO_OBJECT_KEY, customData);
    sessionStorage.removeItem(AMERICO_SESSION_STORAGE_KEY);
    props.history.push('/loan-protection/getting-started');
  };

  const handlePromotedProduct = (ctaType, filter, redirectUri) => {
    if (ctaType === "filter" && filter) {
      const productFilter = filter;
      const obj = { ...filterObject };

      switch (productFilter) {
        case "digitalOnly":
          if (!obj[productFilter]) {
            filterRef.current.updateFilterState(productFilter);
          } else {
            filterRef.current.updateFilterState("allApplicationType");
          }
          break;
        case "phoneOnly":
          if (!obj[productFilter]) {
            filterRef.current.updateFilterState(productFilter);
          } else {
            filterRef.current.updateFilterState("allApplicationType");
          }
          break;
        case "medicalExamOnly":
          if (!obj[productFilter]) {
            filterRef.current.updateFilterState(productFilter);
          } else {
            filterRef.current.updateFilterState("allRequirements");
          }
          break;
        case "noMedicalExamOnly":
          if (!obj[productFilter]) {
            filterRef.current.updateFilterState(productFilter);
          } else {
            filterRef.current.updateFilterState("allRequirements");
          }
          break;
        case "levelTerm":
          if (!obj[productFilter]) {
            filterRef.current.updateFilterState(productFilter);
          } else {
            filterRef.current.updateFilterState("allTermProductType");
          }
          break;
        case "decreasingTerm":
          if (!obj[productFilter]) {
            filterRef.current.updateFilterState(productFilter);
          } else {
            filterRef.current.updateFilterState("allTermProductType");
          }
          break;
        case "convertibleOnly":
          if (!obj[productFilter]) {
            filterRef.current.updateFilterState(productFilter);
          } else {
            filterRef.current.updateFilterState("allConversionOptions");
          }
          break;
        case "notConvertibleOnly":
          if (!obj[productFilter]) {
            filterRef.current.updateFilterState(productFilter);
          } else {
            filterRef.current.updateFilterState("allConversionOptions");
          }
          break;
        default:
          break;
      }
      setFilterObject(obj);
      scrollToTop();
    }

    if (ctaType === "redirect" && redirectUri) {
      props.history.push(redirectUri);
      scrollToTop();
    }
  };
  return (
    <Container className='pt-4 bg-color'>
      <Row className='customized-term-quoter haven-digital'>
        <header>
            <BasicInfoSummary
                coverageAmount={coverageAmount}
                setCoverageAmount={setCoverageAmount}
                marks={DigitalCoverageAmounts(isHavenSI, props.isAmerico)}
                termLength={termLength}
                setTermLength={setTermLength}
                setHealthClass={setHealthClass}
                setTermStructure={setTermStructure}
                healthClass={healthClass}
                termStructure={termStructure}
                multiTermFilter={multiTermFilter}
                basicInfo={basicInfo}
                isActivePurl={isActivePurl}
                isAmerico={props.isAmerico}
                setOpenEditPopUp={setOpenEditPopUp}/>
        </header>
        <QuoterFilters
          isSortedByPrice={isSortedByPrice}
          filterObject={filterObject}
          lowestPrice={lowestPrice}
          fastestRate={fastestRate}
          setSortedByPrice={setSortedByPrice}
          setFilterObject={setFilterObject}
          ref={filterRef}
          isAmerico={props.isAmerico}
        />
        <Col lg={12}>
          <div className={`quote-results-grid-container ${accountObj.account.enableTraditionalTerm && props.isAmerico ? "has-traditional-term" : ""}`}>
            <div className="quote-results-sort-container">
            { !props.isAmerico && <QuoterSort
                isSortedByPrice={isSortedByPrice}
                filterObject={filterObject}
                lowestPrice={lowestPrice}
                fastestRate={fastestRate}
                setSortedByPrice={setSortedByPrice}
                setFilterObject={setFilterObject}
              />}
            </div>

            {props.isAmerico && <Fragment>
              <div className="quote-results-header-start-container padding-top">
                <h3>Instant Issue Options</h3>
                <p>{quoteResultsValueProp}</p>
              </div>
              <div className="quote-results-header-end-container">
              <SaveQuoteButton
                type='quote-screen'
                title="Save my quote"
                loading={loading || americoLoading}
                quoteLogId={quoteLogId}
                isActivePurl={isActivePurl}
                setQuoteSaved={setQuoteSaved}
                isQuoteSaved={isQuoteSaved}
                setEmailPrefill={(e) => props.setEmailPrefill(e)}
                setQuoteEmail={() => props.setQuoteEmail()}
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
                setEmailModal={{
                  enableInitialEmailCapture: enableInitialEmailCapture,
                  enableTimeoutEmailCapture: enableTimeoutEmailCapture,
                  initialEmailCaptureDisplayed: initialEmailCaptureDisplayed,
                  timeoutEmailCaptureDisplayed: timeoutEmailCaptureDisplayed,
                }}
                setTimeoutEmailDisplayed={() => setTimeoutEmailDisplayed()}
                setInitialEmailDisplayed={() => setInitialEmailDisplayed()}
                saveQuoteData={saveQuoteData}
                handleContactChange={handleContactChange}
              />
              </div>
              <div className={`quote-results-content-container single ${(displayedAmericoQuoteResult.length < 1 && !loading) ? "no-results" : ""}`}>
                <QuoteResults
                americoQuoter={true}
                coverageAmount={coverageAmount}
                termLength={parseInt(termLength)}
                results={displayedAmericoQuoteResult}
                tobacco={basicInfo.tobacco}
                loading={loading || americoLoading}
                setSelectedQuote={quoteOnClick}
                fullFormState={props.fullFormState}
                onMultiFieldChange={props.onMultiFieldChange}
                handleAmericoModalShow={handleAmericoModalShow}
                handleAmericoQuoteOnNext={handleAmericoQuoteOnNext}
                isSortedByPrice={isSortedByPrice}
                isAmerico={props.isAmerico}
                onlyAmerico={props.isAmerico}
                history={props.history}
                />
              </div>
            </Fragment>}
            { ((accountObj.account.enableTraditionalTerm && props.isAmerico) || !props.isAmerico) && <Fragment>
              <div className="quote-results-header-start-container">
                <h3>{!props.isAmerico ? "Top Coverage Options" : "Traditional Term Options"}</h3>
                {!props.isAmerico && <p>{quoteResultsValueProp}</p>}
              </div>
              <div className="quote-results-header-end-container">
              {!props.isAmerico && <SaveQuoteButton
                type='quote-screen'
                title="Save my quote"
                loading={loading || americoLoading}
                quoteLogId={quoteLogId}
                isActivePurl={isActivePurl}
                setQuoteSaved={setQuoteSaved}
                isQuoteSaved={isQuoteSaved}
                setEmailPrefill={(e) => props.setEmailPrefill(e)}
                setQuoteEmail={() => props.setQuoteEmail()}
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
                setEmailModal={{
                  enableInitialEmailCapture: enableInitialEmailCapture,
                  enableTimeoutEmailCapture: enableTimeoutEmailCapture,
                  initialEmailCaptureDisplayed: initialEmailCaptureDisplayed,
                  timeoutEmailCaptureDisplayed: timeoutEmailCaptureDisplayed,
                }}
                setTimeoutEmailDisplayed={() => setTimeoutEmailDisplayed()}
                setInitialEmailDisplayed={() => setInitialEmailDisplayed()}
                saveQuoteData={saveQuoteData}
                handleContactChange={handleContactChange}
              /> }
              </div>
              <div className={`quote-results-content-container ${(displayedQuoteResults.length < 1 && !loading) || (coverageAmount < 50000 && !loading) ? "no-results" : ""}`}>
                <QuoteResults
                coverageAmount={coverageAmount}
                termLength={parseInt(termLength)}
                results={displayedQuoteResults}
                tobacco={basicInfo.tobacco}
                loading={loading || americoLoading}
                setSelectedQuote={quoteOnClick}
                fullFormState={props.fullFormState}
                onMultiFieldChange={props.onMultiFieldChange}
                handleAmericoModalShow={handleAmericoModalShow}
                isSortedByPrice={isSortedByPrice}
                isAmerico={props.isAmerico}
                history={props.history}
                />
                {(props.isAmerico ? (quotesWithoutAmerico.length > quoteLimit) : (filteredQuoteResults.length > quoteLimit)) && (!loading) &&
                  <div className={`quote-results-toggle-container ${classes.toggleBackground}`}>
                    <button onClick={toggleQuoteResults} className={`${classes.buttonClass}`}>
                      {displayAllQuotes ? <RemoveCircleOutlineOutlinedIcon color='primary' className='icon-margin'/> :
                        <AddCircleOutlineOutlinedIcon color='primary' className='icon-margin'/>}
                      <span
                        className={`title ${classes.darkenText}`}>{displayAllQuotes ? "Show fewer quotes" : `${props.isAmerico ? (quotesWithoutAmerico.length - quoteLimit) : (filteredQuoteResults.length - quoteLimit)} more quotes`}</span>
                    </button>
                  </div>}
              </div>
            </Fragment>}
            <div className="quote-results-footer-container">
              
              <Button variant='outlined' className='contact-btn float-right' color='primary' size='medium'
                    onClick={() => getSpecialistHelp()}>
              CONTACT A SPECIALIST</Button>
            </div>
          </div>
          {isTestimonialPanelEnable && <Testimonials isShowCard={true} isShowPanel={true}/>}
          <TermInsuranceTools
            loading={loading || americoLoading}
            errorMessage={errorMessage}
            setErrorMessage={(value) => setErrorMessage(value)}
            isQuoteSaved={isQuoteSaved}
            setQuoteSaved={(value) => setQuoteSaved(value)}
            quoteLogId={quoteLogId}
            healthClass={healthClass}
            terms={termLength}
            coverageAmount={coverageAmount}
            setCoverageAmount={setCoverageAmount}
            setTermLength={setTermLength}
            onHealthClassChange={handleHealthClassChange}
            basicInfo={basicInfo}
            />

          { promotedProducts && (promotedProductCount > 0) && <CtaSolution data={promotedProducts} productType={props.productType} handlePromotedProduct={handlePromotedProduct}/> }
        </Col>
      </Row>
      {americoModalShow &&
        <AmericoQuoteModel
          history={props.history}
          fullFormState={props.fullFormState}
          handleAmericoModalClose={props.isAmerico ? handleAmericoQuoteOnNext : handleAmericoModalClose}
          americoModalShow={americoModalShow}
          coverageAmount={coverageAmount}
          termLength={termLength}
          healthClass={healthClass}
          basicInfo={basicInfo}/>
      }
      {basicInfoModalShow && 
        <BasicInfoSummaryModel 
          openEditPopUp={basicInfoModalShow}
          closeModal={() => setBasicInfoModalShow(false)} 
          setOpenEditPopUp={handleBasicInfoSubmit}
          isPurlVerification={isPurlVerification}
          isAmerico={props.isAmerico}
          formState={props.formState}
          product={'term3'}
          selectedQuote={selectedQuote} />}
    </Container>
  );
}

function QuoteResults(props) {
  if (props.loading) {
    return (
      <div className='loading-container'>
        <LoadingGrid single={(props.isAmerico && props.onlyAmerico) ? true : false} />
      </div>
    );
  }
  
  const withoutAmerico = (!props.americoQuoter && props.results) ? props.results.filter(r => r.productID !== QuoteProductID.AMERICO_TERM_PRODUCT_ID) : [];
  const filteredResults = props.isAmerico ? ((props.isAmerico && props.onlyAmerico) ? props.results : withoutAmerico) : props.results ? props.results.filter(r => r.monthlyRate > 0) : [];
  if (filteredResults.length < 1) {
    if (props.coverageAmount < 50000) {
      return <NoQuoteAvailable
      subText="Some values may not meet minimum requirements. Please update the coverage amount or term length, or click 'Show other options' below."/>;
    } 
    return <NoQuoteAvailable
    subText="Some limits may have been exceeded. Please select a shorter term duration or click 'Show other options' below."/>;
  }
  return (
    <div className='term-quote-result-section-container'>

      {filteredResults && filteredResults.map((r, i) =>
        <QuoteResult
          index={i}
          key={i}
          coverageAmount={props.coverageAmount}
          termLength={props.termLength}
          tobacco={props.tobacco}
          result={r}
          loading={props.loading}
          onSelectClicked={() => props.setSelectedQuote(r)}
          fullFormState={props.fullFormState}
          onMultiFieldChange={props.onMultiFieldChange}
          handleAmericoModalShow={props.handleAmericoModalShow}
          handleAmericoQuoteOnNext={props.handleAmericoQuoteOnNext}
          isSortedByPrice={props.isSortedByPrice}
          isAmerico={props.isAmerico}
          history={props.history}
        />
      )}
    </div>
  );
}

QuoteResults.propTypes = {
  results: PropTypes.array,
  coverageAmount: PropTypes.number,
  termLength: PropTypes.number,
  loading: PropTypes.bool,
  isSortedByPrice: PropTypes.bool,
  isAmerico: PropTypes.bool,
  fullFormState: PropTypes.object,
  onMultiFieldChange: PropTypes.func,
  handleAmericoModalShow: PropTypes.func,
  tobacco: PropTypes.string,
};

function QuoteResult(props) {
  const [expanded, setExpanded] = useState(false);
  const { result, onSelectClicked, index } = props;
  return (
    <div className='term-quote-result-section'>
      {result &&
        <TermQuoteCard
          index={index}
          carrierName={result.carrierName}
          productName={result.product}
          underwritingTime={result.underwritingTimeTypical}
          quote={result}
          expanded={expanded}
          expand={() => setExpanded(!expanded)}
          monthlyRate={result.monthlyRate}
          logoUrl={result.logoUrl}
          rating={result.rating}
          onClick={() => {
            const form = { ...props.fullFormState };
            if (!props.isAmerico) {
              form.pages.quoter.carrierName = result.carrierName;
              form.pages.quoter.carrierLogoUrl = result.logoUrl;
              form.pages.quoter.premium = result.monthlyRate;
              form.pages.quoter.product = result.product;
              form.pages.quoter.cashValue = result.cashValue !== null ? result.cashValue : null;
              form.pages.quoter.logoUrl = result.logoUrl;
              form.pages.quoter.selectedQuote = result;
              props.onMultiFieldChange(form);
              if (result.carrierName !== "Americo") {
                onSelectClicked();
              } else {
                props.handleAmericoModalShow();
              }
            } else {
              form.steps.quoter.carrierName = result.carrierName;
              form.steps.quoter.carrierLogoUrl = result.logoUrl;
              form.steps.quoter.premium = result.monthlyRate;
              form.steps.quoter.product = result.product;
              form.steps.quoter.cashValue = result.cashValue !== null ? result.cashValue : null;
              form.steps.quoter.logoUrl = result.logoUrl;
              props.onMultiFieldChange(form);
              if (result.productID === QuoteProductID.AMERICO_TERM_PRODUCT_ID) {
                onSelectClicked();
              } else {
                form.pages.quoter.carrierName = result.carrierName || "";
                form.pages.quoter.carrierLogoUrl = result.logoUrl || "";
                form.pages.quoter.premium = result.monthlyRate;
                form.pages.quoter.product = result.product;
                form.pages.quoter.cashValue = result.cashValue !== null ? result.cashValue : null;
                form.pages.quoter.logoUrl = result.logoUrl;
                form.pages.quoter.selectedQuote = result;
                props.onMultiFieldChange(form);
                onSelectClicked();
              }
            }
          }}
          isBestPrice={result.isBestPrice}
          isFastest={result.isFastest}
          isFeatured={result.isFeaturedCarrier}
          isDigitalProduct={result.isDigitalProduct}
          isSortedByPrice={props.isSortedByPrice}
          hasConvertibility={result.hasConvertibility}
          requiresPhoneInterview={result.requiresPhoneInterview}
          requiresMedicalExam={result.requiresMedicalExam}
          applicationInformation={result.applicationInformation}
          productDetails={<ProductDetails
            carrierName={result.carrierName}
            productDescription={result.productDescription}
            productInformation={result.productInformation}
            hasPermConversion={result.hasPermConversionOption}
          />}
        />
      }
    </div>
  );
}

QuoteResult.propTypes = {
  result: PropTypes.object,
  isSortedByPrice: PropTypes.bool,
  isAmerico: PropTypes.bool,
  fullFormState: PropTypes.object,
  onMultiFieldChange: PropTypes.func,
  onSelectClicked: PropTypes.func,
  index: PropTypes.number,
  handleAmericoModalShow: PropTypes.func,
};
 
Quoter.propTypes = {
  location: PropTypes.object,
  formState: PropTypes.object,
  preQuoteDetails: PropTypes.object,
  basicInfo: PropTypes.object,
  multiTermResult: PropTypes.bool,
  fullFormState: PropTypes.object,
  onMultiFieldChange: PropTypes.func,
  onNext: PropTypes.func,
  onNextBestow: PropTypes.func,
  onNextHaven: PropTypes.func,
  onNextLga: PropTypes.func,
  history: PropTypes.object,
};

Quoter.DefaultFormState = (clientInfo = null) => {
  return {
    coverageAmount: (clientInfo && clientInfo.faceAmount) || 0,
    healthClass: (clientInfo && clientInfo.healthClass) || 'PP',
    coverageLength: (clientInfo && clientInfo.termLength) || 0,
    termStructure: ['Level', 'Decreasing'],
    isSelectOrTalk: "quoteSelect",
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/steps/Quoter.js